import React from "react";

const OrderCancelled = () => {
  return (
    <div className="order-page" style={{marginTop:"115px"}}>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb">
        Home &gt; My Account &gt; My Orders &gt; <span>OD43636930323848100</span>
      </div> */}

      <div className="order-wrapper">
        {/* LEFT */}
        <div className="order-left">
          <div className="order-card">
            {/* PRODUCT HEADER */}
            <div className="product-header">
              <div>
                <h5>
                  SINGHTECH AW950 RGB GAMING MOUSE Wired Ambidextrous Optical
                  Gaming Mouse
                </h5>
                <p className="muted">Black</p>
                <p className="muted">Seller: SANWALIYATRADERS</p>
                <h4>₹216</h4>
              </div>

              <img
                src="https://rukminim2.flixcart.com/image/312/312/xif0q/mouse/h/x/z/aw950-singhtech-original-imaghhgzfd8rmjxe.jpeg"
                alt="product"
              />
            </div>

            <hr />

            {/* STATUS */}
            <div className="status-box">
              <div className="status-row confirmed">
                <span className="icon green">✓</span>
                <p>Order Confirmed, Today, Dec 27</p>
              </div>

              <div className="status-line"></div>

              <div className="status-row cancelled">
                <span className="icon red">✕</span>
                <p>Cancelled, Today, Dec 27</p>
              </div>
            </div>

            <a href="#" className="updates-link">
              See All Updates →
            </a>

            {/* <div className="chat-box">
              <span>💬</span> Chat with us
            </div> */}
          </div>

          {/* FEEDBACK */}
          <div className="feedback-card">
            <h4>Rate your experience</h4>

            <div className="feedback-row">
              🛒 How was your cancellation experience?
              <span>›</span>
            </div>

            <div className="feedback-row">
              👍 Did you find this page helpful?
              <span>›</span>
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="order-right">
          <div className="side-card">
            <h4>Delivery details</h4>

            <div className="info-box">
              <p>
                🏠 <strong>Home</strong> Annapurna daily needs Gadge nagar,
                Near Han...
              </p>
              <p>
                👤 <strong>Prajwal Punatkar</strong> 9325996893
              </p>
            </div>
          </div>

          <div className="side-card">
            <h4>Price details</h4>

            <div className="price-row">
              <span>Listing price</span>
              <span className="strike">₹500</span>
            </div>

            <div className="price-row">
              <span>Selling price</span>
              <span>₹200</span>
            </div>

            <div className="price-row">
              <span>Total fees</span>
              <span>₹16</span>
            </div>

            <hr />

            <div className="price-row total">
              <span>Total amount</span>
              <span>₹216</span>
            </div>

            <div className="payment-box">
              Payment method <strong>Cash On Delivery</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderCancelled;